export default {
  boothPrice: 'Booth price',
  standard_booth: 'Standard booth',
  blank_booth: 'Blank booth',
  configuration: 'Configuration',
  price: 'Price',
  base: 'Base',
  viewPrice: 'View price',
  boothSampleGraph: 'Booth sample graph',
  tip: 'For reference only, the actual booth configuration shall prevail',
  viewFloorPrice: 'View floor price',
  configInfo1: {
    item1: 'Carpet',
    item2: 'A desk',
    item3: '2~3 chair',
    item4: 'A wastebasket',
    item5: 'Company lintel board',
    item6: '2~3 spotlight',
    item7: 'Two (three) face wall panels'
  },
  configInfo2: {
    item1: 'No facilities included',
    item2: 'Comply with pavilion restrictions',
    item3: 'Minimum size required'
  }
}
